export default "__VITE_ASSET__9bb9c8b5__"